export default "__VITE_ASSET__12a1008c__"